// This file now only exports the login request configuration
// The MSAL config is created in index.tsx after the config file is loaded

// Scopes for Microsoft Graph API
export const loginRequest = {
  scopes: ['User.Read', 'email'], // Basic user profile information
};
